//? List of X-POWERED-BY headers
//> Reference URL: https://maqentaer.com/devopera-static-backup/http/devfiles.myopera.com/articles/554/httpheaders-x-powered-by-url.htm

export const xPowerList = [
  'asp.net',
  'php/4.4.7',
  'php/4.4.4',
  'php/4.3.9',
  'php/5.2.4',
  'php/5.1.6',
  'php/4.3.10',
  'php/4.3.11',
  'php/4.4.2',
  'php/5.2.3',
  'php/4.4.6',
  'php/5.2.1',
  'php/5.0.4',
  'php/4.4.1',
  'php/5.1.4',
  'php/4.3.2',
  'php/4.3.10-22',
  'php/5.1.2',
  'php/4.4.0',
  'php/5.2.0',
  'php/5.2.0-8+etch7',
  'pleskwin',
  'php/4.3.4',
  'php/4.4.4-8+etch4',
  'php/4.3.8',
  'php/4.1.2',
  'php/5.2.2',
  'php/4.3.10-16',
  'php/4.3.3',
  'php/4.4.3',
  'php/4.4.3-dev',
  'php/5.0.5',
  'php/4.2.2',
  'php/4.3.6',
  'php/4.4.2-1.1',
  'php/4.3.10-18',
  'php/5.0.3',
  'php/4.3.1',
  'php/4.3.10-19',
  'php/4.2.3',
  'modlayout/3.2',
  'modlayout/3.2.1',
  'php/4.4.5',
  'php/4.4.7-0.dotdeb.0',
  'php/4.4.7-0+tld0',
  'php/5.2.4_p20070914-pl2-gentoo',
  'php/5.2.5',
  'php/4.4.7-1',
  'php/4.4.8_pre20070816-pl0-gentoo',
  'ez publish',
  'php/5.1.1',
  'php/4.3.7',
  'php/4.3.0',
  'php/4.3.10-21',
  'php/5.1.5',
  'php/4.4.4-8+etch3',
  'php/4.4.2-1build1',
  'php/4.0.6',
  'php/4.4.7-pl0-gentoo',
  'php/4.4.4-0.dotdeb.3',
  'php/5.2.4-0+tld0',
  'the blood, sweat and tears of the fine, fine textdrive staff',
  'modlayout/4.0.2a',
  'php/4.4.4-8+etch1',
  'php/5.2.4-pl2-gentoo',
  'php/4.4.4-9+lenny1',
  'php/4.4.4 with hardening-patch',
  'php/5.2.2-pl1-gentoo',
  'php/5.2.1-0.dotdeb.1',
  'php/5.2.4-0.dotdeb.0',
  'php/4.3.10-15',
  'webserver',
  'modlayout/5.0',
  'php/3.0.18',
  'php/4.4.7-0.dotdeb.1',
  'modlayout/4.0.1a',
  'php/4.4.4-pl6-gentoo',
  'php/5.0.2',
  'php/4.3.5',
  'php/5.2.0-8+etch4',
  'php/4.4.4-8',
  'php/5.2.0-8+etch1',
  'php/4.4.4-9',
  'php/5.2.0-8',
  'php/4.3.10-20',
  'servlet 2.4; jboss-4.0.5.ga (build: cvstag=branch_4_0 date=200610162339)/tomcat-5.5',
  'php/5.2.4-0.dotdeb.1',
  'php/5.2.3-1+b1',
  'php/5.2.0-0.dotdeb.3',
  'php/5.2.3-0.dotdeb.0',
  'php/4.4.0-pl1-gentoo',
  'php/5.1.6-pl6-gentoo',
  'php/5.2.0-8+etch5~pu1',
  'php/4.4.4-8+etch2',
  'php/5.1.6-0.dotdeb.2',
  'php/5.2.3-1+lenny1',
  'servlet/2.4 jsp/2.0',
  'php/5.1.4-debian-0.1~sarge1',
  'php/4.4.7-0.nexen.0',
  'php/4.4.6-0.dotdeb.2',
  'php/5.2.3-0.dotdeb.1',
  'zend core/2.0.1 php/5.2.3',
  'php/5.2.1-pl3-gentoo',
  'php/5.2.3-1ubuntu6',
  'php/4.4.5-dev',
  'php/4.0.4pl1',
  'servlet 2.4; jboss-4.0.3sp1 (build: cvstag=jboss_4_0_3_sp1 date=200510231054)/tomcat-5.5',
  'php/5.2.0-10',
  'php/5.0.1',
  'php/4.4.0-4',
  'zope (www.zope.org), python (www.python.org)',
  'php/4.4.2-debian-0.1~sarge1',
  'php/4.2.1',
  'php/4.4.2-0.dotdeb.1',
  'php/5.1.6-0.dotdeb.1',
  'php/5.2.4_pre200708051230-pl2-gentoo',
  'servlet 2.4; jboss-4.0.4.ga (build: cvstag=jboss_4_0_4_ga date=200605151000)/tomcat-5.5',
  'php/4.4.8-dev',
  'php/4.4.6-pl0-gentoo',
  'php/4.1.1',
  'modlayout/3.4',
  'php/4.4.1-0.dotdeb.2',
  'freeweb.hu/v2.31',
  'dragonfly cms using php engine',
  'php/4.4.4-0.dotdeb.1',
  'php/5.0.0',
  'php/4.4.2-1',
  'php/4.4.0-3ubuntu2',
  'php/4.4.8_pre20070816-pl0-udmedia',
  'php/5.2.0-8+etch3',
  'servlet 2.4; jboss-4.0.2 (build: cvstag=jboss_4_0_2 date=200505022023)/tomcat-5.5',
  'php/4.3.10-2',
  'php/5.1.6-pl11-gentoo',
  'php/5.2.0-8+etch7~bpo.1',
  'php/5.0.5-debian-0.8~sarge1',
  'php/4.3.9-1.dotdeb.3',
  'php/4.4.4-8+etch4yoyo',
  'php/5.1.3rc4-dev',
  'php/4.4.6-dev',
  'php/4.1.0',
  'asp.net 2.0',
  'servlet 2.4; tomcat-5.0.28/jboss-4.0.1sp1 (build: cvstag=jboss_4_0_1_sp1 date=200502160314)',
  'modlayout/3.0.3',
  'php/4.4.4-1',
  'php/5.2.5-pl0-gentoo',
  'urlrewriter.net 1.7.0',
  'php/5.1.4-0.1',
  'php/4.4.5-0.dotdeb.2',
  'php/5.1.6 with hardening-patch',
  'php/4.4.7-0byte1',
  'php/4.3.11-0.dotdeb.0',
  'php/5.2.3-0+tld0',
  'php/4.4.2-1+b1',
  'php/4.0.5',
  'php/5.1.6-pl4-gentoo',
  'php/5.2.2-dev',
  'php/5.1.6-1',
  'php/4.4.2-pl2-gentoo',
  'php/4.4.0-gentoo-r1',
  'servlet 2.4; tomcat-5.0.28/jboss-3.2.7 (build: cvstag=jboss_3_2_7 date=200501280217)',
  'php/4.3.10-1.dotdeb.0',
  'php/5.1.6-1~bpo.1',
  'epages 5',
  'php/5.2.4-2',
  'php/5.2.1-debian-3~orbus1',
  'php',
  'php/4.4.4-3',
  'php/5.2.0-10+lenny1',
  'php/4.4.6-0.dotdeb.1',
  'urlrewriter.net 2.0.0',
  'php/4.2.4-dev',
  'php/5.2.3-pl3-gentoo',
  'php/4.4.7-tuxtools',
  'sff net',
  'php/4.4.0-0.dotdeb.0',
  'mod_xlayout_jh/0.0.1vhs.markii.remix',
  'php/4.4.2 with hardening-patch',
  'php/5.2.1-0.dotdeb.1.cga.1',
  'saf/4.0rc1',
  'php/5.1.4-pl0-gentoo',
  'zend core/2.0.1 php/5.2.1',
  'jsp/2.0',
  'php/4.4.4-8+etch2+spbutters1',
  'php/5.2.4-1+b1',
  'php/5.2.0-8+etch1~bpo.1',
  'php/5.2.4-1',
  'php/4.3.10-10ubuntu4.8',
  'php/5.2.5-dev',
  'php/5.1.6-pl8-gentoo',
  'intesoft-aspaccelerator/3.7.0.0',
  'mod_xslt/0.5',
  'php/4.2.0',
  'php/5.0.4-1.dotdeb.1',
  'servlet 2.4; tomcat-5.0.28/jboss-4.0.1 (build: cvstag=jboss_4_0_1 date=200412230944)',
  'modlayout/4.1',
  'ebd/3.2.8',
  'php/5.1.4-pl6-gentoo',
  'php/4.0.3pl1',
  'php/5.0.5-2ubuntu1.4',
  'php/5.2.0-8~bpo.2',
  'php/4.4.4-pl8-gentoo',
  'jsp/2.1',
  'php/4.4.2rc2-dev',
  'segpub',
  'alpine internet solutions inc.',
  'php/4.4.0-0.la02.0',
  'servlet/2.4',
  'php/4.4.3-pl1-gentoo',
  'php/4.3.4rc1',
  'php/5.1.2-1.dotdeb.2',
  'php/4.4.6-2+b1',
  'php/4.3.9-1',
  'php/5.1.0rc1',
  'php/3.0.15',
  'php/5.2.5-0.dotdeb.1',
  'php/3.0.16',
  '',
  'php/4.3.11-dev',
  'servlet 2.4; tomcat-5.0.28/jboss-3.2.6 (build: cvstag=jboss_3_2_6 date=200410140106)',
  'php/4.3.10-banan16',
  'justpageit 1.0',
  'php/5.2.0-7',
  'smugmug/1.2.0',
  'php/5.2.2-0.dotdeb.1',
  'php/5.2.3-1',
  'php/4.3.10-10ubuntu3.7',
  'iatp',
  'php/4.3.10-9',
  'php/4.3.10-22aaa+tigertech2',
  'php/5.2.2-0.dotdeb.0',
  'servlet 2.4; jboss-4.2.0.ga (build: svntag=jbpapp_4_2_0_ga date=200706281411)/tomcat-5.5',
  'webstream.net',
  'internet concepts',
  'php/5.1.0',
  'ihtml/2.20.1600',
  'php/4.0.4',
  'php/4.4.4-pl4-gentoo',
  'servlet/2.5',
  'php/5.1.4-1.dotdeb.1',
  'php/5.2.5-0.dotdeb.0',
  'php/5.1.2-1+b1',
  'php/5.1.6-5',
  'zend core/2.5.0 php/5.2.4',
  'php/4.4.0-3',
  'coldfusion',
  'php/4.3.10-alt',
  'servlet/2.4,jsp/2.0',
  'php/4.4.1-0.dotdeb.3.cga.1',
  'php/4.4.4-6',
  'php/4.4.0 with hardening-patch',
  'php/5.1.4-1.dotdeb.2',
  'php/4.4.2-90claranet',
  'php/5.0.5-pl5-gentoo',
  'ipyramid.system/1.5',
  'php/4.3.11/cx1',
  'slash 2.005000182',
  'servletexec/5.0, servlet/2.4, jsp/2.0',
  'php/5.1.3',
  'php/4.4.1-pl1',
  'mubble',
  'php/5.2.4-dev',
  'modlayout/2.11.8',
  'php/5.2.0-8+etch4~bpo.1',
  'seagull http://seagullproject.org',
  'clisp/2.41 postgresql/8.2.3',
  'php/4.3.3rc1',
  'php/4.0.1pl2',
  'subdivisions',
  'modlayout/3.1.7',
  'php/5.1.2-1',
  'asp.net pragma: no-cache',
  'php/4.3.10-13',
  'php/5.1.4-pl4-gentoo',
  'php/4.0.0',
  'servlet 2.4; jboss-4.2.1.ga (build: svntag=jboss_4_2_1_ga date=200707131605)/tomcat-5.5',
  'vb.net',
  'php/5.0.5-2ubuntu1.8',
  'php/5.2.3-1ubuntu6.2',
  'php/4.0.2',
  'php/5.1.4-pl3-gentoo with hardening-patch',
  'zend core/1.5.0 php/5.1.6',
  'servlet 2.4; jboss-4.2.0.ga (build: svntag=jboss_4_2_0_ga date=200705111440)/tomcat-5.5',
  'php/4.3.3rc3',
  'phaistos networks homepages deployment system 1.1',
  'php/4.3.10-22.1',
  'zend core/1 php/5.0.5',
  'php/5.1.6-pl6-gentoo with hardening-patch',
  'php/4.3.9-1.dotdeb.1',
  'webpress 11.00.2',
  'php/4.4.2-0.zbanan.1',
  'slash 2.005000181',
  'microsoft windows 3.11',
  'php/5.1.4-0.0bpo1',
  'php/4.3.5rc3',
  'php/4.4.4-8+etch4.1',
  'php/5.1.2-gentoo',
  'php/4.4.2annyung',
  'php/3.0.14',
  'php/4.3.10-8',
  'php/4.4.1annyung',
  'php/4.4.3rc2-dev',
  'netcat/2.4.244 (standard)',
  'php/5.1.4-1.dotdeb.3',
  'php/5.1.2-pl0-gentoo',
  'php/4.3.3-20030903',
  'php/4.4.2-pl6-gentoo',
  'servletexec/5.0.0.13, servlet/2.4, jsp/2.0',
  'php/5.2.4-pl0-gentoo',
  'servlet 2.4; tomcat-5.0.28/jboss-4.0.0 (build: cvstag=jboss_4_0_0 date=200510191036)',
  'php/4.4.5annyung',
  'ihtml/2.20.1561',
  'php/5.2.4-5.2.4',
  'php/5.2.0-0.dotdeb.1',
  'php/4.4.2-pl0-gentoo',
  'startweb.es',
  'coldfusion mx 7.1',
  'the county of oxford',
  'servlet 2.4; jboss-4.0.3sp1 (build: cvstag=jboss_4_0_3_sp1 date=200510231751)/tomcat-5.5',
  'php/4.4.4-8+etch5',
  'php/5.2.0-8~bpo.1',
  'mabb hosting',
  'countdown',
  'servlet 2.4; tomcat-5.0.28/jboss-3.2.7-caib1 (build: cvstag=jboss_3_2_7_p1 date=200511211329)',
  'php/4.4.1-0.dotdeb.3',
  'php/4.3.8-12',
  'servlet 2.4; tomcat-5.0.28/jboss-4.0.0 (build: cvstag=jboss_4_0_0 date=200409200418)',
  'netcat/2.4.243 (standard)',
  'php/4.3.11rc1-dev',
  'php/5.2.3-0.nexen.0',
  'jmg',
  'php/4.3.11-pl5-gentoo',
  'ihtml/2.20.1050',
  'php/4.4.4-pl4-gentoo with hardening-patch',
  'ihtml/2.20.1549',
  'php/4.3.8-8.dotdeb.1',
  'php/4.4.2-gentoo',
  'php/5.1.6-4',
  'conquest (2.4.9)',
  'php/4.3.12-dev/alt',
  'php/4.4.1-pl3-gentoo',
  'php/5.1.4-20060505',
  'cryohost.net',
  'php/5.1.5 with hardening-patch',
  'php/4.4.4-tuxtools',
  'http://www.ids.it',
  '""',
  'php/4.3.10-12',
  'php/4.4.0-pl1-gentoo with hardening-patch',
  'php/5.2.1-0.dotdeb.2',
  'php/4.4.3-0.dotdeb.1',
  'ihtml/2.20.1346',
  'php/4.4.2-1.0.0jones1',
  'php/5.0.5-1.dotdeb.1',
  'php/4.3.5rc2',
  'wc1i',
  'php/5.1.2-0bpo1',
  'servlet 2.4; jboss-4.0.2 (build: cvstag=jboss_4_0_2 date=20050704)/tomcat-5.5',
  'ihtml/2.20.1602',
  'roadsend php sitemanager 2.5.0',
  'php/4.4.0-1',
  'zoovy/v.z123',
  'zoovy/v.d06',
  'php/5.0.4-0.9sarge1',
  'php/5.0.5-3',
  'php/5.1.6-6',
  'slash 2.003000',
  'php/5.1.6annyung',
  'vif-proserver',
  'php/5.0.3-1.dotdeb.0',
  'php/5.1.5-0.dotdeb.1',
  'php/5.2.1-dev',
  'php/4.3.2rc4',
  'php/4.3.1-dev/alt',
  'sitesupra? v.3.1.20',
  'php/5.0.5-20051114',
  'php/4.4.1-pl3-gentoo with hardening-patch',
  'php/5.1.4 with hardening-patch',
  'atwrewriter/1.1',
  'php/4.4.2-pl1',
  'php/4.3.10-20.bcn1',
  'zoovy/v.d02',
  'khxc/6.6.2',
  'php/5.0.4-20050405',
  'php/4.4.3rc3-dev',
  'php/5.1.2-0bpo7.mysql41.0',
  'php/5.2.2-2',
  'servlet/2.5 jsp/2.1',
  'www3 asp.net',
  'php/4.3.10-ntk1',
  'php/5.2.0-dev',
  'php/4.4.2-dev',
  'php/5.0.4-debian-0.15~sarge1',
  'bluerange sitemanager 1.2',
  'php/4.4.4-dev',
  'php/4.4.2-1build1_a24old_2',
  'ws',
  'php/4.3.10-99',
  'site.head(tm)',
  'php/5.1.4-1',
  'php/5.2.0-8+etch3+spbutters1',
  'php/4.4.7-dev',
  'web',
  'php/5.0.4-dev',
  'biferno (<a href="http://www.biferno.it">http://www.biferno.it</a>)',
  'servlet 2.4; tomcat-5.0.28/jboss-3.2.8.sp1 (build: cvstag=jboss_3_2_8_sp1 date=200603031235)',
  'efekt',
  'php/4.2.2-m10',
  'mediapoint',
  'php/4.4.1 with hardening-patch',
  'ihtml/2.20.1568',
  'php/5.0.5-2ubuntu1.6',
  'php/4.4.1-dev/alt',
  'php/4.4.4-pl6-gentoo with hardening-patch',
  'netcat/2.4.244 (extra)',
  'php/5.1.6-20060908',
  'webprojects.co.uk',
  'php/4.3.9-2',
  'maksimum.net',
  'php/5.1.4-pl3-gentoo',
  'ant-on! 2.5.2',
  'php/4.4.0rc2',
  'servlet 2.4; jboss-4.0.3 (build: cvstag=jboss_4_0_3 date=200510042324)/tomcat-5.5',
  'php/4.3.10annyung',
  'slash 2.005000184',
  'php/5.2.4-tuxtools',
  'php/4.4.4-8+etch3+spbutters1',
  'zend core/1 php/5.1.4',
  'smartsite v4',
  'apache/2.2.4 (unix) mod_ssl/2.2.4 openssl/0.9.7a php/4.4.7 and zoomway.co.uk ems/1.0.1',
  'php/4.3.10-102',
  'wc1j',
  'php/5.1.0-dev',
  'coldfusion mx',
  'php/5.1.0rc4',
  'jumanji for php',
  'php/4.4.0-3ubuntu1',
  'php/5.2.3-20070601',
  'php/5.1.4-debian-0.1~dapper1',
  'php/5.2.0-8+etch7~bpo.1aaa+tigertech2',
  'php/4.4.2rc3-dev',
  'wc1b',
  'eep 2.0.9.5742',
  'intercom 2.1.103 (c) interso 1999-2004',
  'php/4.3.2-rc',
  'php/4.4.1-dev',
  'apache/2.2.4 (unix) mod_ssl/2.2.4 openssl/0.9.7a php/4.4.6 and zoomway.co.uk ems/1.0.1',
  'php/4.4.2-1 with hardening-patch',
  'php/5.0.5-2ubuntu1',
  'php/4.4.1-0.dotdeb.1',
  'zend core/2.0.0 php/5.2.1',
  'gigaweb webhosting',
  'php/5.2.3-1+b2',
  'php/5.1.4-pl6-gentoo with hardening-patch',
  'hardened-php/4.3.10',
  'jsf/1.2',
  'ipyramid.system/1.0',
  'php/5.2.1-20070215',
  'ihtml/2.20.1579',
  'php/4.3.11-pl1-gentoo',
  'php/5.1.4annyung',
  'php/5.2.0rc5-dev',
  'eaccelerator',
  'server',
  'zoovy/v.d08',
  'zoovy/v.z101',
  'php/5.2.4-20070910',
  'open2b software',
  'cfmx',
  'php/5.0.5-pl3-gentoo',
  'php/4.4.6rc2-dev',
  'php/5.1.6-debian-0.1~sarge1',
  'flexites ltd',
  'slash 2.002006',
  'khxc/6.6.1',
  'bestbbs v4.01',
  'php/4.3.3rc2',
  'php/5.0.3-20041216',
  'ipyramid.start/1.5',
  'php/6.0.0-dev',
  'netdoc',
  'php/5.1.4-debian-0.1~breezy1',
  'zoovy/v.d01',
  'webdirector',
  'php/4.4.5rc2-dev',
  'php/4.4.4-8+etch4+spbutters1',
  'servlet 2.4; jboss-4.0.3-eici (build: cvstag=jboss_4_0_3_sp1 date=200510231054)/tomcat-5.5',
  'php/4.3.8-20040719',
  'php/5.1.1-gentoo',
  'servlet 2.4; jboss-4.0.4.cr2 (build: cvstag=jboss_4_0_4_cr2 date=200603311500)/tomcat-5.5',
  'wc1e',
  'zncm/3.1.1',
  'php/4.3.10rc2',
  'php/5.1.2-debian-0.1~sarge1',
  'php/5.2.3-dev',
  'php/5.2.0-0.dotdeb.2',
  'arukereso engine',
  'php/4.4.6-tuxtools',
  'php/4.4.0-gentoo-r1 with hardening-patch',
  'php/5.2.0-20061229',
  'aka brian tangent',
  'servlet 2.4; tomcat-5.0.28/jboss-3.2.6 (build: cvstag=jboss_3_2_6 date=200705231031)',
  'sitesupra? v.3.1.42',
  'web construction set(tm)',
  'php/4.3.8-9',
  'slash 2.005000183',
  'php/5.2.2-1+b1',
  'mmbase_1.8.0',
  'php/3.0.17',
  'php/4.3.9-dev',
  'netcat/2.4 (standard)',
  'php/4.4.2-1build1_a24',
  'php/5.1.4-0.1~bpo2',
  'zoovy/v.d07',
  'php/5.2.0-8+etch3~bpo.1',
  'netcat/2.4.244 (plus)',
  'netcat/2.3 (standard)',
  'php/4.4.4-2',
  'dlh.net',
  ': asp.net',
  'altlayout/1.0',
  'wc1h',
  'php/4.3.6rc3',
  'php/5.1.4-pl1-gentoo',
  'php/4.3.8-5',
  'netcat/2.4.243 (extra)',
  'php/4.3.10-16+gmp0',
  'wips/2.0',
  'php/4.3.5rc1',
  'php/5.2.1rc4-dev',
  'php/4.3.11topmania',
  'php/5.2.0rc2-dev',
  'php/4.3.10-20041216',
  'x-site/1.0 (dedicated to fox)',
  'x-media script 4.0',
  'php/4.3.10-10',
  'php/4.3.9-dev/alt',
  'seagull 0.4.0dev2',
  'php/4.3.10-200.schlund.1',
  'php/5.0.5annyung',
  'php/5.2.0-9',
  'wc1d',
  'php/5.0.5-2ubuntu1.3',
  'strike interactive llc',
  'bluetree cms 2.1',
  'alpine center stage professional v3.0',
  'php/5.1.4-debian-0.1',
  'php/4.4.7-0.suhosin.2',
  'awalnet web server 2.0',
  'an apache webserver and some cool scripts :-)',
  'intesoft-aspredirector/1.7.5000.0',
  'apache',
  'php/4.3.11annyung',
  'wildcat.net v6.1.451.7',
  'php/4.3.3rc4',
  'servletexec/5.0.0.12, servlet/2.4, jsp/2.0',
  'php/4.3.10-10ubuntu3.5',
  'free rein cms',
  'zoovy/v.z120',
  'php/5.0.5-2ubuntu1.2',
  'html::mason',
  'saf/3.0rc1',
  'php/5.0.5-2ubuntu1.5',
  'php/4.3.10-10ubuntu3',
  'php/4.3.10-22 visionic/2.1.3',
  'daniel rehbein',
  'pure alcohol',
  'php/5.1.0b3',
  'php/5.2.0-8mcw',
  'happiness',
  'mod_pdcgi(micex persistent direct cgi) $revision: 1.9 $',
  'sitesupra? v.3.0.3109',
  'andris ludrix [php/4.3.10]',
  'wildcat.net v6.2.452.2',
  'php/5.2.2-20070509',
  'iguana php framework',
  'php/4.3.11-4:4.3.11',
  'irpublish',
  'php/4.4.7-20070504',
  'openvolano.org',
  'php/5.0.6-dev',
  'intesoft-aspredirector/1.7.0.0',
  'php/4.3.10-16.swsoft.1',
  'php/4.4.2-0.dotdeb.2',
  'php/5.0.0rc3',
  'php/5.2.0rc7-dev',
  'php/5.2.0rc6-dev',
  'php/4.3.11p1',
  'php/4.4.4-0.dotdeb.5',
  'php/5.2.5-pl1-gentoo',
  'asp.net,',
  'wildcat.net v6.2.452.3',
  'php/4.4.6-2',
  'php/5.1.4-pl0-gentoo with hardening-patch',
  'sihv.contissimo-engine 20070705',
  'modlayout/3.0',
  'asp.net 707',
  'php/4.4.4-7',
  'eskort/2',
  'php/4.3.0rc2',
  'phpbabytalk 0.1',
  'php/5.0.4-0.6.sarge.1',
  'php/4.1.2-20020326',
  'slash 2.005000152',
  'php/5.2.3 (x64)',
  'ihtml/2.20.948',
  'php/5.2.3-1ubuntu6.1',
  'modlayout/3.3',
  'php/5.1.4-0.1sarge',
  'php/4.3.10-frank15',
  'matchbox/3.3',
  'zoovy/v.z122',
  'ebd/3.1.4',
  'php/5.0.3-dev',
  'php/5.2.4_p20070914-pl2-udmedia',
  'cms using php engine',
  'php/4.3.4-dev',
  'php/5.2.4-0.dotdeb.1.cga.1',
  'zend core/2.0.0 php/5.1.6',
  'php/5.1.2-debian-0.1~breezy1',
  'php/4.4.6-0.dotdeb.2.0',
  'kentauras v.3',
  'php/4.4.6-0.dotdeb.3',
  'ihtml/2.20.924)',
  'hardened-php/4.3.11',
  'php/4.4.4-pl2-gentoo',
  'flycms/4',
  'khxc/6.6.0',
  'ebd/3.2.4',
  'tar.hu/v2.00',
  'netcat/2.4.240 (standard)',
  'php/5.2.4_p20070914-pl0-gentoo',
  'php/5.1.4-20060814',
  'coldfusion 8',
  'php/5.1.2-20060306',
  'php/5.0.5-dev',
  'php/5.2.1 (x64)',
  'servlet 2.4; tomcat-5.0.28/jboss-3.2.8 (build: cvstag=jboss_3_2_8 date=200602101241)',
  'php/5.0.0rc2',
  'servlet 2.4; jboss-4.2.2.ga (build: svntag=jboss_4_2_2_ga date=200710221139)/tomcat-5.5',
  'fastcommerce',
  'php/5.1.6-pl4-gentoo with hardening-patch',
  'muon',
  'php/4.3.2-rc1',
  'iit madras brains',
  'php/4.4.1-20051114',
  'alpine center stage standard v3.0',
  'itlab/5.0 (standard sight)',
  'zaman newspaper application server 1.1',
  'zend core/2.0.0 php/5.2.1rc2',
  'btphp/1.3.2',
  'php/4.3.9rc1',
  'php/4.4.3-pl1-gentoo with hardening-patch',
  'servlet 2.4; jboss-4.0.4rc1 (build: cvstag=jboss_4_0_4_rc1 date=200602071519)/tomcat-5.5',
  'inform (infocentre)',
  'netcat/2.4 ()',
  'zolid ez publish',
  'php/4.3.2topmania',
  'php/4.4.0rc2-dev',
  'kaspercms3',
  'netcat/2.3.235 (standard)',
  'php/4.4.4-20061212',
  'netcat/2.4.244 ()',
  'mc3 sms (mc3 core version 1.4.0 sp6 firebrick (11 sep 2006)), http://mc3.telecom.by/',
  'webzone srl http://www.webzone.it',
  'www4 asp.net',
  'andris ludrix [php/4.1.0]',
  'php/5.2.4 header($expire); cache-control: max-age=3600, must-revalidate',
  'php/4.3.5rc4',
  'php/4.3.5-dev',
  'web marketing associates',
  'ecms/1.0 (http://loopback.no/)',
  'asp.net ralste 2003',
  'jboss',
  'php/4.4.2-pl3-gentoo',
  'php/5.2.0-20061205',
  'php/4.3.10rc1',
  'html',
  'ven brussels www.ven.be',
  'ihtml/2.20.1492',
  'php/4.3.2-rc2',
  'roadsend php sitemanager 2.6.1',
  'php/5.0.5-debian-0.8',
  'php/4.4.7-1.pocos.1etch.2',
  'php/5.0.4-1.dotdeb.2',
  'php/5.1.2annyung',
  'php/4.3.5rc2-dev/alt',
  'php/4.4.0-2',
  'php/4.3.10-10ubuntu4',
  'php/4.4.2sf4',
  'godwot site generator',
  'cambio cms 1.0',
  'php/4.3.3rc2-dev',
  'webbler version 3.2.1',
  'php/4.4.1-x86_64',
  'asp.net:',
  'php/5.3.0-dev',
  'rocket-media.net',
  'dmmd gmbh & co. kg',
  'aksess publisering 5.1',
  'php/5.2.0rc4-dev',
  'php/4.3.5-dev/alt',
  'php/5.1.3-dev',
  'artemy.info',
  'php/4.3.11-gentoo-r1',
  'adobe coldfusion 8 enterprise',
  'php/5.2.4rc1',
  'ihtml/2.20.1529',
  'php/5.2.1animgif',
  'php/5.2.0-8+etch7+spbutters1',
  'ihtml/2.20.1540',
  'webbler version 3.1.5',
  'php/4.3.10-21.kwartz.0',
  'php/4.1.2oops',
  'php/5.2.1rc2-dev',
  'urlrewriter.net 1.8.0',
  'dewezet.de',
  'wildcat.net',
  'php/5.1.1-1.dotdeb.2',
  'unsanity_steam/2006',
  'php/5.2.1, php/5.2.1',
  'modlayout/2.11.13',
  'php/4.1.2, php/4.1.2',
  'php/4.3.12-20050419',
  'lussumo vanilla 1.1.4',
  'php/5.1.2-1.dotdeb.1',
  'wc1g',
  'xs2 v1.30.4.071203-1627',
  'php/4.0.6a',
  'php/5.2.1rc5-dev'
]

const size = xPowerList.length

export const xpbRandomSync = () => xPowerList[Math.floor(Math.random() * size)]

export const xpbRandom = async () => xpbRandomSync()

export const asyncXPBR = async (req, res, next) => {
  res.setHeader('X-Powered-By', await xpbRandom())
  next()
}

export const syncXPBR = (req, res, next) => {
  res.setHeader('X-Powered-By', xpbRandomSync())
  next()
}

